module.exports = __webpack_public_path__ + "45020ec4d02e4fe453d8bdb67bf691e8.png";